import {Box} from '@mantine/core';
import Head from 'next/head';
import type {PropsWithChildren} from 'react';
import isAppWebView from '../../../config/isAppWebView';
import {RegisterFooter} from './Container/Presenter/RegisterFooter';
import {RegisterHeader} from './Container/Presenter/RegisterHeader';

export const RegisterLayout = ({children}: PropsWithChildren) => {
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0,maximum-scale=1.0"
        />
      </Head>
      <div>
        {!isAppWebView() && <RegisterHeader />}
        <main>
          <Box className="flex justify-center min-h-screen w-full bg-background-1 py-12 pc:py-32">
            <div className="flex flex-col items-center w-full max-w-[1200px]">
              {children}
            </div>
          </Box>
        </main>
        {!isAppWebView() && <RegisterFooter />}
      </div>
    </>
  );
};
